import React, { useState, useEffect } from 'react';
import * as s from './styled-filtra-vars';
import { icons } from '../../../../assets';

// Chips de familia: cada chip define um keyword que filtra variaveis
// cujo nome (ou ihmname) contem essa string. Cobre as familias mais
// comuns das ~300 variaveis disponiveis. Operador clica o chip pra
// pular direto pra famosa familia em vez de digitar.
const FAMILY_CHIPS = [
  { key: 'temperatura', label: 'Temperatura' },
  { key: 'vibracao', label: 'Vibração' },
  { key: 'pressao', label: 'Pressão' },
  { key: 'corrente', label: 'Corrente' },
  { key: 'potencia', label: 'Potência' },
  { key: 'energia', label: 'Energia' },
  { key: 'tensao', label: 'Tensão' },
  { key: 'nivel', label: 'Nível' },
];

const PesquisaVars = ({ setFilter }) => {
  const [value, setValue] = useState('');

  // Debounce sutil: cada tecla aplica o filtro em 250ms — evita
  // re-render da lista de ~300 cards a cada keystroke.
  useEffect(() => {
    const timer = setTimeout(() => {
      setFilter(value);
    }, 250);
    return () => clearTimeout(timer);
  }, [value, setFilter]);

  const activeChipKey = value.toLowerCase().trim();

  return (
    <s.Wrapper>
      <s.SearchBox>
        <s.SearchIcon src={icons.SearchIcon} alt="" />
        <s.SearchInput
          type="text"
          placeholder="Buscar variável…"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          maxLength={40}
        />
        {value && (
          <s.ClearButton
            type="button"
            aria-label="Limpar busca"
            onClick={() => setValue('')}
          >
            ×
          </s.ClearButton>
        )}
      </s.SearchBox>
      <s.ChipsRow>
        {FAMILY_CHIPS.map((chip) => {
          const isActive = activeChipKey === chip.key;
          return (
            <s.Chip
              key={chip.key}
              type="button"
              aria-pressed={isActive ? 'true' : 'false'}
              onClick={() => setValue(isActive ? '' : chip.key)}
            >
              {chip.label}
            </s.Chip>
          );
        })}
      </s.ChipsRow>
    </s.Wrapper>
  );
};

export default PesquisaVars;
